export default {
    fund: [{
            "title": "基金公司的主要利润来源是（　　）。",
            "question": "A. 投资收益\nB. 基于资产管理规模的管理费\nC. 基金所持股票分红\nD. 交易佣金",
            "answer": "B",
            "explain": "本题考查基金公司的主要利润来源。\nA、C选项错误，投资收益以及基金所持股票分红，属于基金的利润来源，不属于基金公司的利润来源。\nD选项错误，交易佣金属于基金的费用，不属于基金公司的利润来源。\nB选项正确，基金公司的主要利润来源是基于资产管理规模的管理费。"
        },
        {
            "title": "某一时期内，一只股票型基金的β值为0.8，收益率的标准差为0.4，平均收益率为12.4%，无风险利率为4%，则该股票型基金的夏普比率与特雷诺比率分别为（　　）。",
            "question": "A. 0.105, 0.22\nB. 0.104, 0.21\nC. 0.22, 0.105\nD. 0.21, 0.105",
            "answer": "D",
            "explain": "本题考查夏普比率与特雷诺比率。"
        },
        {
            "title": "某个投资者以1元的基金净值申购某基金10000份后又以1.1元的基金净值赎回该基金10000份，不考虑费用的话，该投资者此项获利需缴纳的税收情况是（　　）。",
            "question": "A. 应缴个人所得税50元\nB. 应缴个人所得税200元\nC. 暂不征收个人所得税\nD. 应缴个人所得税100元",
            "answer": "C",
            "explain": "本题考查个人投资者投资基金征收的个人所得税。\n个人投资者申购和赎回基金份额取得的差价收入，在对个人买卖股票的差价收入未恢复征收个人所得税以前，暂不征收个人所得税。本题中的投资者申购和赎回基金份额取得的差价收入，暂不征收个人所得税。"
        },
        {
            "title": "某公司发行了面值为100元的3年期零息债券，现在的市场利率为10%，则该债券的现值为（　　）。",
            "question": "A. 70.00元\nB. 82.64元\nC. 75.13元\nD. 133.10元",
            "answer": "C",
            "explain": "本题考查零息债券估值方法。\n债券内在价值计算公式:V=M/(1+r)^t, 式中:V表示贴现债券的内在价值;M表示面值;r表示市场利率;t表示债券到期时间。本题中，M=100，r=10%，t=3，将数值代入公式得:V=100/(1+10%)^3=75.13。"
        },
        {
            "title": "俗话说“一手交钱一手交货”，但在一些债券交易中却不适用，例如（　　）。",
            "question": "A. 债券的T+1卖出\nB. 债券的T+0买入\nC. 债券的分销\nD. 债券借贷的首期",
            "answer": "D",
            "explain": "本题考查债券借贷业务。\nA、B、C选项不符合题意，债券的T+1卖出、债券的T+0买入、债券的分销采用货银对付原则，又称款券两讫或钱货两清原则，指证券登记结算机构与结算参与人在交收过程中，当且仅当资金交付时给付证券，证券交付时给付资金，即“一手交钱，一手交货”。\nD选项符合题意，债券借贷的首期采用券券对付结算方式。“一手交钱一手交货”并不适用。"
        },
        {
            "title": "股票未来收益的现值被称为股票的（　　）。",
            "question": "A. 票面价值\nB. 清算价值\nC. 内在价值\nD. 账面价值",
            "answer": "C",
            "explain": "本题考查股票的价值与价格。\nA选项不符合题意，股票的票面价值又称面值，即在股票票面上标明的金额。"
        }, {
            "title": "目前，基金管理公司应定期编制并对外提供的基金财务会计报告，不包括（　　）。",
            "question": "A. 半年度报告\nB. 日报告\nC. 季度报告\nD. 年度报告",
            "answer": "B",
            "explain": "本题考查基金财务报告的种类。\n基金管理公司应及时编制并对外提供真实、完整的基金财务报告。财务会计报告分为年度(D选项不符合题意)、半年度(A选项不符合题意)、季度(C选项不符合题意)和月度财务会计报告。\n综上所述，A、C、D选项不符合题意，B选项符合题意。"
        },
        {
            "title": "使用内在价值法对股票进行估值，不同的现金流决定了不同的现金流贴现模型，股利贴现模型（DDM）采用的现金流是（　　）。",
            "question": "A. 权益自由现金流\nB. 企业自由现金流\nC. 留存收益\nD. 现金股利",
            "answer": "D",
            "explain": "本题考查股利贴现模型的概念。\n假定股利是投资者在正常条件下投资股票所直接获得的唯一现金流，则可以建立估价模型对普通股进行估值，这就是著名的由威廉姆斯和戈登提出的股利贴现模型。即股利贴现模型（DDM）采用的现金流量现金股利。"
        },
        {
            "title": "下列选项中列入基金费用的是（　　）。",
            "question": "A. 基金合同生效前所发生的验资费、会计师和律师费、信息披露等费用\nB. 基金管理人和基金托管人处理与基金运作无关的事项发生的费用\nC. 基金运作而正常发生的开户费、银行汇划手续费，持有人大会费等费用\nD. 基金管理人和基金托管人因未履行或未完全履行义务导致的费用支出或基金财产的损失",
            "answer": "C",
            "explain": "本题考查列入基金费用的项目。\n下列费用不列入基金费用：\n(1)基金管理人和基金托管人因未履行或未完全履行义务导致的费用支出或基金财产的损失；(D选项不符合题意)\n(2)基金管理人和基金托管人处理与基金运作无关的事项发生的费用；(B选项不符合题意)"
        },
        {
            "title": "以下关于不同证券持有者的证券的清偿顺序，正确的是（　　）。",
            "question": "A. 优先股、债券、普通股\nB. 普通股、优先股、债券\nC. 债券、优先股、普通股\nD. 债券、普通股、优先股",
            "answer": "C",
            "explain": "本题考查各类资本的清偿顺序。\n各类资本的清偿顺序为：\n(1)债权资本是一种借入资本，代表了公司的合约义务，因此债券持有者/债权人拥有公司资产的最高索取权；\n(2)接着是优先股股东，在公司解散或破产清算时，优先股股东优先于普通股股东分配公司剩余财产；"
        },
        {
            "title": "关于名义利率与实际利率，以下表述正确的是（　　）。",
            "question": "A. 实际利率是物价不变且购买力不变情况下的利率\nB. 实际利率包含对通货膨胀补偿的利率\nC. 名义利率比实际利率低\nD. 名义利率是指物价有变化，扣除通货膨胀补偿以后的利率",
            "answer": "A",
            "explain": "本题考查名义利率与实际利率的概念及关系。\nA选项表述正确，B、D选项表述错误，实际利率指在物价不变且购买力不变情况下的利率，或者是指当物价有变化，扣除（并非包含）通货膨胀补偿以后的利息率。\nC选项说法错误，名义利率是指包含对通货膨胀补偿的利率，当物价不断上涨时，名义利率比实际利率高（并非低）。"
        },
        {
            "title": "半强有效证券市场中证券价格未反映的信息是（　　）。",
            "question": "A. 尚未公告的管理层决策\nB. 已公告的股票分拆方案\nC. 该股票的历史价格\nD. 分析师已发布的对该公司的盈利预测",
            "answer": "A",
            "explain": "本题考查半强有效市场。\n半强有效市场是指证券价格不仅已经反映了历史价格信息，历史信息包括证券的价格、交易量等，而且反映了当前所有与公司证券有关的公开有效信息，例如盈利预测、红利发放、股票分拆、公司并购等各种公告信息。"
        }, {
            "title": "某固定利率债券面值为100元，票面利率为4%，每年付息一次，期限为2年，市场利率为5%，用贴现现金(DCF)估值法计算该债券的内在价值为（　　）。",
            "question": "A. 98.14\nB. 101.89\nC. 102.85\nD. 99.28",
            "answer": "A",
            "explain": "本题考查固定利率债券估值法。\n固定利率债券的内在价值计算公式为：\nV=C/(1+r)^1 + C/(1+r)^2 + ... + (C+M)/(1+r)^n，式中：V表示固定利率债券的内在价值；C表示每期支付的利息；M表示面值；r表示市场利率；n表示债券到期时间。本题中，M=100,r=5%,C=100*4%,n=2。\n将数值代入公式得：\nV=(100*4%)/(1+5%)^1 + (100*4%)/(1+5%)^2 + 100/(1+5%)^2 = 98.14（元）"
        },
        {
            "title": "以下选项中，不属于经营活动产生的现金流量的是（　　）。",
            "question": "A. 支付的各项税费\nB. 提供劳务收到的现金\nC. 支付给职工以及职工支付的现金\nD. 购建固定资产支付的现金",
            "answer": "D",
            "explain": "本题考查经营活动产生的现金流量。\n经营活动产生的现金流量是与生产商品、提供劳务缴纳税金等直接相关的业务所产生的现金流。\n本题中，支付的各项税费、提供劳务收到的现金、支付给职工以及职工支付的现金均属于经营活动产生的现金流量；购建固定资产支付的现金属于投资活动产生的现金流量，D选项符合题意。"
        },
        {
            "title": "关于利率互换和货币互换，以下表述正确的是（　　）。",
            "question": "A. 利率互换的合约双方互换的是不同币种下的相同利率\nB. 利率互换的合约一方具有货币交换的权利，而没有货币交换的义务\nC. 利率互换的合约双方互换的是不同币种为单位的利率\nD. 利率互换的合约双方互换的是双方认为具有相等经济价值的现金流",
            "answer": "D",
            "explain": "本题考查利率互换。\n利率互换(interest rate swap)，是指互换合约双方同意在约定期限内按不同的利息计算方式分期向对方支付由币种相同的名义本金额所确定的利息。由于双方使用相同的货币，利率互换采用净额支付的方式，即互换双方不交换本金，只按期由一方向另一方支付本金所产生的利息净额。利率互换有两种形式"
        },
        {
            "title": "关于个人投资者的总体特征，以下表述正确的是（　　）。",
            "question": "A. 资金雄厚，投资规模大\nB. 投资行为规范\nC. 投资管理专业\nD. 常常需要借助基金销售服务机构进行投资",
            "answer": "D",
            "explain": "本题考查个人投资者的特征。\n个人投资者的特征包括：\n(1)投资需求受个人所处生命周期的不同阶段和个人境况的影响，呈现较大的差异化特征；\n(2)可投资的资金量较小；"
        },
        {
            "title": "某日a投资者在场内申购了b货币ETF，则该笔交易是用的交收规则是（　　）。",
            "question": "A. T+1货银对付担保交收\nB. T+0逐笔非担保交收\nC. T+0货银对付担保交收\nD. T+1逐笔非担保交收",
            "answer": "A",
            "explain": "本题考查货币ETF申购业务的交收规则。\n目前，货银对付已经成为各国（地区）证券市场普遍遵循的原则。我国证券市场中，在多边净额结算方式下，已实现对ETF交易、单市场股票ETF及单市场债券ETF申购与赎回的份额和现金替代、货币ETF申购与赎回等业务进行T+1货银对付担保交收。"
        },
        {
            "title": "目前，我国银行间债券市场的业务不包括（　　）。",
            "question": "A. 债券借贷\nB. 债券分销\nC. 债券期货\nD. 债券回购",
            "answer": "C",
            "explain": "本题考查银行间债券市场结算业务类型。\n债券结算的业务包括分销业务、现券业务、质押式回购业务、买断式回购业务、债券远期交易、债券借贷、利率互换业务。\nA选项不符合题意，债券借贷是指债券融入方以一定数量的债券为质物，从债券融出方借入标的债券，同时约定在未来某一日期归还所借入标的债券，并由债券融出方返还相应质物的债券融通行为，属于我国银行间债券市场的业务。"
        }, {
            "title": "对于不含期权的债券，当债券收益率分别上升和下降相同单位时，以下说法正确的是（　　）。",
            "question": "A. 债券价格会随之反向变动，且价格上升幅度小于下降幅度\nB. 债券价格会随之同向变动，且价格上升幅度等于下降幅度\nC. 债券价格会随之反向变动，且价格上升幅度大于下降幅度\nD. 债券价格会随之反向变动，且价格上升幅度等于下降幅度",
            "answer": "C",
            "explain": "本题考查到期收益率的影响因素。\n在其他因素相同的情况下，债券市场价格与到期收益率呈反方向增减。债券的价格---收益率曲线是一条凸向原点的曲线，当债券收益率分别上升和下降相同单位时，价格上升幅度大于下降幅度。"
        },
        {
            "title": "可用于市现率模型估值法的现金流包括（　　）。",
            "questions": "I、EBITDA<br>II、营运现金流<br>III、自由现金流",
            "question": "A. II、III\nB. I\nC. I、II、III\nD. I、III",
            "answer": "C",
            "explain": "本题考查相对估值法。\n由于公司盈利水平容易被操纵而现金流价值通常不易操纵，市价/现金比率(市现率)越来越多地被投资者所采用。"
        },
        {
            "title": "以下不属于资产负债表中资产项的会计科目是（　　）。",
            "question": "A. 应收账款\nB. 存货\nC. 无形资产\nD. 实收资本",
            "answer": "D",
            "explain": "本题考查资产负债表的组成部分。\n资产是指企业所拥有或掌握的，以及被其他企业所欠的各种资源或财产。资产包括流动资产和非流动资产。\n流动资产包括货币资金、应收账款、应收票据、存货以及其他流动资产；非流动资产包括固定资产、无形资产、长期股权投资以及其他非流动资产。\n实收资本是指投资者作为资本投入企业的各种财产，是企业注册登记的法定资本总额的来源，它表明所有者对企业的基本产权关系。"
        },
        {
            "title": "关于资本市场理论，以下表述错误的是（　　）。",
            "question": "A. β系数衡量资产收益率相对市场组合收益率变化的敏感程度\nB. CAPM模型中的前提假设可以归结为所有投资者一致和市场有效这两条\nC. 市场组合处于有效前沿，但不同投资者的市场组合点不同\nD. 单个资产的风险溢价与市场投资组合M的风险溢价和该资产的系数成比例",
            "answer": "C",
            "explain": "本题考查资本市场理论。\n市场组合处于有效前沿。市场组合是最优风险投资组合，即资本配置线(CAL)与有效边界的切点。因此，资本市场线（CML)，即从无风险利率到市场组合M的线也是可获得的最佳资本配置线。所有投资者均将M作为其最佳风险投资组合，区别在于市场组合资产与无风险资产的配比。"
        },
        {
            "title": "下列关于基金公司投资交易流程的表述，错误的是（　　）。",
            "question": "A. 交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易\nB. 在自主权限内，基金经理通过交易系统向交易室下达交易指令\nC. 交易员负责审核投资指令（价格、数量）的合法合规性，对于可能不盈利指令可以拒绝\nD. 基金公司投资交易包括形成投资策略、构建投资组合、执行交易指令、绩效评估与组合调整、风险控制等环节",
            "answer": "C",
            "explain": "交易总监审核投资指令（价格、数量）的合法合规性，并将指令分派给交易员。投资交易系统将自动拦截违规指令，如果发现异常指令时由交易总监反馈信息给基金经理并有权终止指令，同时报上级主管领导，并通知合规风控部门。"
        },
        {
            "title": "平均收益率为40%，标准差为0.5，前一年定期利率为5%，夏普比率为（　　）。",
            "question": "A. 0.65\nB. 0.8\nC. 0.7\nD. 0.6",
            "answer": "C",
            "explain": "本题考察夏普比率的计算。\n夏普比率是用某一时期内投资组合平均超额收益率除以这个时期收益的标准差，其计算公式为：\n\\[Sp = \\frac{R_p - R_f}{\\sigma_p}\\]"
        }, {
            "title": "有关场内证券交易中的大宗交易，以下表述正确的是（　　）。",
            "question": "A. 上海证券交易所和深圳证券交易所的大宗交易申报时间有所差异\nB. 大宗交易平台可以接受当日停牌股票的交易申报\nC. 证券交易所调整大宗交易的最低限额须经证监会审批同意\nD. 大宗交易是指单个投资人单日对单个证券交易累计量达到一定数额的证券买卖",
            "answer": "A",
            "explain": "本题考查大宗交易。\n大宗交易是指单笔数额较大的证券买卖。\n我国现行有关交易制度规定，如果证券单笔买卖申报达到一定数额的，证券交易所可以采用大宗交易方式进行。\n按照规定，证券交易所可以根据市场实际情况调整大宗交易的最低限额。上海证券交易所接受大宗交易的时间为每个交易日9:30---11:30、13:00---15:00。"
        },
        {
            "title": "关于贝塔系数，以下说法正确的是（　　）。",
            "question": "A. 贝塔系数小于1大于0时，该投资组合的价格变动幅度比市场大\nB. 贝塔系数等于1时，该投资组合的价格变动幅度与市场变动幅度一致\nC. 贝塔系数大于0时，该投资组合的价格变动方向与市场相反\nD. 贝塔系数等于0时，该投资组合的价格变动方向与市场同步",
            "answer": "B",
            "explain": "本题考查贝塔系数的表示意义。\nA选项说法错误，贝塔系数小于1大于0时，该投资组合的价格变动幅度比市场小(并非大)。"
        },
        {
            "title": "若某年通胀率为2%，年利率为1.5%，则实际利率为（　　）。",
            "question": "A. -0.50%\nB. 1.50%\nC. 3.50%\nD. 0.50%",
            "answer": "A",
            "explain": "由费者方程式可知，实际利率=名义利率-通货膨胀率"
        },
        {
            "title": "以下资产配置中，可以有效降低组合非系统性风险的是（　　）。",
            "question": "A. 分别一倍做多螺纹钢期货和购买螺纹钢现货\nB. 分别购买同一家公司发行的可转债和优先股\nC. 分别购买不同公司发行的沪深300ETF基金\nD. 分别购买纸黄金和实物黄金",
            "answer": "C",
            "explain": "本题考查非系统性风险及风险分散化。\n非系统风险可以通过分散化投资降低，风险分散化的效果与资产组合中资产数量是正相关的。"
        },
        {
            "title": "一般来说，以下项目中不体现在基金财务会计报告中的是（　　）。",
            "question": "A. 基金分红能力\nB. 基金持有人明细\nC. 基金盈利能力\nD. 基金费用情况",
            "answer": "B",
            "explain": "本题考查基金财务会计报告分析的内容。"
        },
        {
            "title": "现有A、B两个资产构建投资组合，资产收益率的相关系数在-1和1之间，以下表述正确的是（　　）。",
            "question": "A. 资产收益的相关性不会影响投资组合的风险\nB. 资产收益的相关性会影响投资组合的风险和投资组合的预期收益率\nC. 当两个资产收益率的相关系数为-1时，一定能找到一个点，使得投资组合的标准差为0\nD. 相关系数越小，组合的曲线越往左边弯曲，组合风险越大",
            "answer": "C",
            "explain": "本题考查资产收益的相关性。\nA、B选项错误，资产收益率之间的相关性会影响投资组合的风险，而不会影响投资组合的预期收益率；\nC选项正确，当相关系数ρ=-1时，一定能找到使得投资组合的标准差为0的点，该点组合等效于无风险资产；\nD选项错误，如果资产1和资产2的收益率和相关系数在-1和1之间，当相关系数越小时，组合的曲线越往左弯曲，组合风险越小，组合的效用越高。"
        }, {
            "title": "体现货币时间价值的谚语为（　　）。",
            "question": "A. 早收晚付\nB. 谷贱伤民\nC. 不要为酒掉的牛奶哭泣\nD. 卖的比买的精",
            "answer": "A",
            "explain": "本题考查货币时间价值的概念。\n货币时间价值是指货币随着时间的推移而发生的增值，所以一定金额的资金必须注明其发生时间，才能确切地表达其准确的价值。\nA选项符合题意，所谓“早收晚付”就是针对那些低收益的资金，要尽快的收回，而对于那些低息甚至无息的负债，则要尽量晚付，涉及在两个不同时间的货币价值，体现了货币的时间价值。"
        },
        {
            "title": "进行基金业绩评价不能仅看回报率，以下属于基金业绩评价应考虑的因素的是（　　）。",
            "question": "A. 基金公司股权稳定性\nB. 基金规模\nC. 基金公司资产管理规模\nD. 基金经理从业年限",
            "answer": "B",
            "explain": "本题考查影响基金业绩评价的因素。"
        },
        {
            "title": "C公司2019年报表显示，当年C公司经营活动产生的现金流量为5亿元，投资活动产生的现金流量为4亿元，融资活动产生的现金流量说法正确的是（　　）。",
            "question": "A. C公司2019年是亏损的\nB. C公司2019年净现金流为正\nC. C公司2019年净现金流为负\nD. C公司2019年是盈利的",
            "answer": "B",
            "explain": "本题考查现金流量表。\nB选项说法正确，净现金流=经营活动产生的现金流量(CFO)+投资活动产生的现金流量(CFI)+筹资活动产生的现金流量(CFF)=5+4+(-5)=4亿元，净现金流为正。"
        },
        {
            "title": "关于我国银行间债券市场做市商制度，以下表述错误的是（　　）。",
            "question": "A. 做市商以其自有资金和债券与投资者进行交易\nB. 做市商单向报价并在该价位上接受投资者的交易要求\nC. 在我国银行间债券市场开展做市业务需经中国人民银行批准\nD. 做市商制度有利于提高市场流动性",
            "answer": "B",
            "explain": "本题考查做市商制度。\n做市商制度指在债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。\nB选项说法错误。"
        },
        {
            "title": "反映公司在一定时期内总体经营成果，揭示企业财务状况发生变动的直接原因的是（　　）。",
            "question": "A. 利润表\nB. 现金流量表\nC. 资产负债表\nD. 所有者权益变动表",
            "answer": "A",
            "explain": "本题考查利润表的含义。"
        },
        {
            "title": "偿债基金是指债券发行人通过划拨一定数额资金或者慢慢积累资金的方式形成的存款准备金，目的是在未来某一节点用于金的主要作用就是降低（　　）。",
            "question": "A. 利率风险\nB. 通货膨胀风险\nC. 信用风险\nD. 再投资风险",
            "answer": "C",
            "explain": "本题考查信用风险的概念。\n债券的信用风险又叫违约风险，是指债券发行人未按照契约的规定支付债券的本金和利息，给投资者带来损失的可能性。\n某一节点用于清偿某笔债务，因此其主要作用是降低信用风险。"
        }, {
            "title": "关于债券的到期收益率，以下表述正确的有（　　）。",
            "questions": "I、到期收益率等同于内部收益率<br>II、到期收益率是债券的年利息收入与当前债券市场价格<br>III、用到期收益率作为贴现率，计算出的债券内在价值等同于当前债券市场价格<br>IV、到期收益率相当于按照市场价格买入持有到期债券获得的年平均收益率",
            "question": "A. I、II、IV\nB. I、II、III\nC. II、III、IV\nD. I、III、IV",
            "answer": "D",
            "explain": "本题考查债券的到期收益率。"
        },
        {
            "title": "假定某投资者要求的最低预期收益率为5%，则在以下投资组合中，最优选择是（　　）。",
            "question": "A. 预期收益率4%，标准差5%\nB. 预期收益率4%，标准差4%\nC. 预期收益率5%，标准差5%\nD. 预期收益率5%，标准差6%",
            "answer": "C",
            "explain": "本题考查投资组合收益率的方差和标准差。\n投资者要求的最低预期收益率为5%，故A、B选项不符合题意。"
        },
        {
            "title": "关于基金公司针对操作风险采取的应对措施，以下说法错误的是（　　）。",
            "question": "A. 根据评估结果制定相应的管理措施\nB. 对风险点进行整理、评估\nC. 对业务风险进行评估\nD. 业务进行中无需进行跟踪，但应在业务结束后及时反馈",
            "answer": "D",
            "explain": "本题考查基金公司针对操作风险采取的应对措施。\n对于操作风险，基金公司应当对业务风险进行评估，对风险点进行整理、评估，并制定相应的管理措施，在业务进行中对风险管理跟踪。"
        },
        {
            "title": "关于债券基金，以下表述正确的是（　　）。",
            "questions": "I、通过可转债和打新股获得收益的债券基金，它的风险比纯债基金低<br>II、通过计算组合中所有债券的久期的加权平均值可以得到债券基金的久期<br>III、杠杆率不超过100%<br>IV、长短期配合投资可以防范利率风险",
            "question": "A. II、III、IV\nB. I、IV\nC. I、III\nD. II、IV",
            "answer": "D",
            "explain": "本题考查债券基金的风险管理。"
        },
        {
            "title": "关于证券市场线和资本市场线，以下表述错误的是（　　）。",
            "question": "A. 资本市场线可以运用于有效投资组合\nB. 证券市场线用系统风险(β值)衡量风险\nC. 资本市场线决定最适合的资产配置点\nD. 资本市场线的斜率是市场组合的风险溢价",
            "answer": "D",
            "explain": "本题考查证券市场线与资本市场线的区别。"
        },
        {
            "title": "有关基金费用，以下表述正确的是（　　）。",
            "question": "A. 基金运作费由基金承担\nB. 基金销售服务费由基金管理人承担\nC. 基金管理费按月计提\nD. 基金托管费按月计提",
            "answer": "A",
            "explain": "本题考查基金费用。"
        }, {
            "title": "在某些特定商品的交易中，由于商品具有特殊性或只在少数投资者之间交易，因此产生了（　　）。",
            "question": "A. 指令驱动市场\nB. 保证金交易市场\nC. 报价驱动市场\nD. 经纪人市场",
            "answer": "D",
            "explain": "本题考查经纪人市场。"
        },
        {
            "title": "投资交易中的操作风险是（　　）。",
            "question": "A. 由于汇率变化所产生的基金价值的不确定性\nB. 由于人员、流程、系统或外部因素带来的交易失误，导致基金资产或基金公司遭受损失的风险\nC. 由于宏观政策的变化导致的对基金收益的影响\nD. 由于违反法律、法规、交易所规则、基金合同所导致公司遭受损失的风险",
            "answer": "B",
            "explain": "本题考查市场风险的概念。\n操作风险是指由于人员、流程、系统或外部因素带来的交易失误，导致基金资产或基金公司财产损失，或基金公司声誉受损、受到监管风险。"
        },
        {
            "title": "合格境外机构投资者的投资范围不包括（　　）。",
            "question": "A. 货币基金\nB. 信托投资计划\nC. 股指期货\nD. 股票增发",
            "answer": "B",
            "explain": "本题考查合格境外机构投资者的投资范围。\n合格境外机构投资者的投资范围包括：\n(1)在证券交易所交易或转让的股票、债券和权证；"
        },
        {
            "title": "关于另类投资，以下表述正确的是（　　）。",
            "questions": "I、另类投资的“另类”可以体现在投资标的和投资策略上<br>II、另类投资的“另类”可以体现在投资的组织形式上<br>III、另类投资易于通过市场价格法准确估值<br>IV、另类投资中个人投资者多",
            "question": "A. III、IV\nB. I、IV\nC. I、II\nD. II、III",
            "answer": "C",
            "explain": "本题考查另类投资。"
        },
        {
            "title": "根据我国银行间债券市场结算代理制度，开展结算代理业务的金融机构法人须经（　　）批准。",
            "question": "A. 中国证券投资基金业协会\nB. 中国人民银行\nC. 中国证券业协会\nD. 中国证券监督管理委员会",
            "answer": "B",
            "explain": "本题考查结算代理制度。\n结算代理制度指经由中国人民银行批准可以开展结算代理业务的金融机构法人，受市场其他参与者的委托，为其办理债券结算业务的制度。"
        },
        {
            "title": "我国银行间债券市场的中介服务机构，不包括（　　）。",
            "question": "A. 同业中心\nB. 上海清算所\nC. 上海证券交易所\nD. 中央结算公司",
            "answer": "C",
            "explain": "本题考查银行间债券市场的组织体系。\n银行间债券市场的中介服务机构主要是全国银行间同业拆借中心(简称同业中心)，中央国债登记结算有限责任公司(简称中央结算公司)和银行间市场清算所股份有限公司(简称上海清算所)。"
        }, {
            "title": "张家村有一百户人家，其中首富老张的家产超过亿元。某调查小组在调查了老张家之后就得出结论，张家村户户都是百万富翁，这里老张家的家产是取得是（　　）。",
            "question": "A. 中位值\nB. 最小值\nC. 最大值\nD. 平均值",
            "answer": "D",
            "explain": "本题考查平均数。\n张家村100户人家，老张一户就有过亿元，1亿/100户=100(万)，这样平均算下来，家家都是百万富翁，所以算的是平均值。"
        },
        {
            "title": "与市盈率相比，关于市净率的优点，以下表述错误的是（　　）。",
            "question": "A. 市净率更加适用于资产包含大量现金的公司\nB. 市净率更加适用于经营暂时陷入困难的公司\nC. 市净率将高营、人力资源等考虑在内\nD. 每股净资产数值比每股收益更稳定",
            "answer": "C",
            "explain": "本题考查市净率的优点。\n市净率的优点包括：\n(1)每股净资产通常是一个累积的正值，因此市净率也适用于经营暂时陷入困难的以及有破产风险的公司;(B选项说法正确)\n(2)统计学证明每股净资产数值普遍比每股收益稳定得多;(D选项说法正确)"
        },
        {
            "title": "基金期末可供分配利润为期末资产负债表中未分配利润与未分配利润中已实现部分的（　　）。",
            "question": "A. 差额\nB. 孰低数\nC. 孰高数\nD. 平均数",
            "answer": "B",
            "explain": "本题考查期末可供分配利润的概念。"
        },
        {
            "title": "关于商品期货合约的特征，以下表述错误的是（　　）。",
            "question": "A. 商品期货价格是现货交易的基准价格\nB. 是交易双方根据需要协商订立的非标准化合约\nC. 具有较低的交易成本\nD. 有固定的交易场所",
            "answer": "B",
            "explain": "本题考查期货合约的概念。\n期货合约是指交易双方签署的在未来某个确定的时间按确定的价格买入或卖出某种合约标的资产的合约。"
        },
        {
            "title": "关于另类投资的优势，以下表述错误的是（　　）。",
            "question": "A. 加入另类投资的多元投资组合有可能得到比股票组合更高的收益\nB. 许多另类投资的收益率与传统投资相关性较低\nC. 投资者将另类投资纳入投资组合的目的是提高投资回报和分散风险\nD. 另类投资的波动性都远低于股票市场",
            "answer": "D",
            "explain": "A、B选项正确，许多另类投资的收益率与传统投资相关性较低。在多元投资组合中加入另类投资产品，有可能得到比传统股票和更低的波动。"
        },
        {
            "title": "关于回购协议，以下表述正确的是（　　）。",
            "questions": "I、回购协议的场内交易是指上海证券交易所和深圳证券交易所开办的国债标准回购业务<br>II、回购市场目前以质押式回购为主要交易品种，受让方有权处置出售的国债<br>III、回购协议的场外交易是指银行间国债回购市场，参与者包括中国人民银行、商业银行(包括非国有商业银行)、证券公司、基金公司<br>IV、货币基金可参与回购交易，其资产中政府债可以作为回购协议的抵押品，配置短期回购协议也可以获得流动性和收益",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查银行间债券市场的交易品种。"
        }, {
            "title": "关于货币市场工具，以下表述错误的是（　　）。",
            "question": "A. 货币市场工具在金融市场中发挥着十分重要的功能\nB. 货币市场工具具有较差的流动性和对经济环境的敏感性\nC. 货币市场工具均是债务契约\nD. 货币市场工具产生于信用活动，交易价格为利率",
            "answer": "B",
            "explain": "本题考查货币市场工具的特点。\nA选项表述正确，B选项表述错误，货币市场工具因其具有良好的流动性和对经济环境的敏感性，在金融市场中发挥着重要作用。\nC选项表述正确，货币市场工具的特点之一是均是债务契约。"
        },
        {
            "title": "预期损失(ES)指标相对于风险价值(VaR)指标的优点不包括（　　）。",
            "question": "A. 能衡量尾部损失的平均值\nB. 次可加性\nC. 尾部风险度量\nD. 能衡量投资组合面临的潜在最大损失",
            "answer": "D",
            "explain": "本题考查预期损失。\n风险价值是指在给定的时间区间内和置信水平下，利率、汇率等市场风险要素发生变化时，投资组合所面临的潜在最大损失，不属于风险价值(VaR)指标的优点。"
        },
        {
            "title": "以下选项，不属于市场风险管理的主要措施的是（　　）。",
            "question": "A. 建立针对债券发行人的内部信用评级制度，结合外部信用评级，进行发行人信用风险管理\nB. 加强对重大投资的监测，对基金重仓股，单日个股交易量占该股持仓显著比例、个股交易量占该股流通值显著比例等进行跟踪分析\nC. 密切关注行业的周期性、市场竞争、价格、政策环境和个股的基本面变化，构造股票投资组合，分散非系统性风险\nD. 密切关注宏观经济指标和趋势，重大经济政策动向，重大市场行动，评估宏观经济变化可能给投资带来的系统性风险，定期监测投资组合指标，提出应对策略",
            "answer": "A",
            "explain": "本题考查市场风险的管理措施。\n市场风险管理的措施包括："
        },
        {
            "title": "沪深300指数编制的方法为（　　）。",
            "question": "A. 几何平均法\nB. 派式加权法\nC. 算数平均法\nD. 成交额加权法",
            "answer": "B",
            "explain": "本题考查沪深300指数的概念。\n沪深300指数在上海和深圳证券市场中选取300只A股作为样本，以2004年12月31日为基期，基点为1000点，其计算以调整后的自由流通股本为权重。"
        },
        {
            "title": "某日某基金买入S股票10000股，成交价5元/股，当日卖出Q股票20000股，成交价10元/股。按1%税率征收标准，该基金需缴纳印花税（　　）。",
            "question": "A. 150元\nB. 250元\nC. 50元\nD. 200元",
            "answer": "D",
            "explain": "本题考查印花税的计算。\n目前，我国A股印花税率为单边征收(只在卖出股票时征收)，税率为1%。"
        },
        {
            "title": "关于普通股和优先股，以下表述错误的是（　　）。",
            "question": "A. 优先股的收益为固定的股息收益\nB. 优先股的风险高于普通股\nC. 优先股在分配股利和清算时剩余财产的索取权优先于普通股\nD. 普通股相比于优先股具有更高的潜在收益率",
            "answer": "B",
            "explain": "本题考查普通股和优先股。\n优先股没有到期期限，无须归还股本，每年有一笔固定的股息，相当于永久年金(没有到期期限)的债券，但其股息一般比债券利息要高一些。"
        }, {
            "title": "下列表述中，不属于中国人民银行履行监督管理银行间债券市场职能的是（　　）。",
            "question": "A. 拟定债券市场发展规划\nB. 为市场参与主体提供登记、托管、交易结算等服务\nC. 审核、批准金融机构在银行间债券市场的有关资格\nD. 制定市场管理规定，对市场进行全面监督和管理",
            "answer": "B",
            "explain": "本题考查中国人民银行履行监督管理银行间债券市场职能的内容。\n中央国债登记结算有限责任公司(简称中央结算公司)主要为银行间债券的发行、登记、托管、交易结算、信息发布等服务，并负责维护中债综合业务平台的正常运行。"
        },
        {
            "title": "下列有关通货膨胀风险的说法正确的是（　　）。",
            "question": "A. 通货膨胀将降低基金的实际收益率\nB. 投资者的实际收益率与通货膨胀率呈正相关关系\nC. 通货膨胀率不影响基金的实际收益率\nD. 不论通货膨胀程度如何，投资者的实际收益率都不可能为负数",
            "answer": "A",
            "explain": "实际收益率就是扣除了通货膨胀因素以后的收益率概念，具体是指资产收益率(名义收益率)与通货膨胀率之差。\nA选项说法正确，C选项说法错误，通货膨胀将降低基金的实际收益率。"
        },
        {
            "title": "以下不属于基金费用的是（　　）。",
            "question": "A. 销售服务费\nB. 管理人报酬\nC. 公允价值变动损益\nD. 基金份额持有人大会费用",
            "answer": "C",
            "explain": "本题考查基金费用的种类。\n基金费用包括销售过程中发生的由基金投资者承担的费用和管理过程中发生的由基金承担的费用。\nA选项不符合题意，销售服务费是用于支付销售机构佣金、基金的营销费用以及基金份额持有人服务费等。属于基金费用中在管理费。"
        },
        {
            "title": "某基金10月31日估值表中基金总资产为70亿元，总负债30亿元，总份额50亿，则该基金当日资产净值为（　　）。",
            "question": "A. 30亿元\nB. 70亿元\nC. 40亿元\nD. 20亿元",
            "answer": "C",
            "explain": "本题考查资产净值的计算。\n基金资产净值是从基金资产中扣除基金所有负债，即：基金资产净值=基金资产-基金负债。\n本题中，基金总资产=70亿元，总负债=30亿元，将数值代入得，基金资产净值=70-30=40亿。"
        },
        {
            "title": "关于中央银行票据，以下表述正确的是（　　）。",
            "question": "A. 央票市场的参与主体有中国人民银行、各金融机构和经过特许的个人投资者\nB. 中国人民银行与商业银行的票据交易不改变商业银行超额准备金的数量\nC. 央票分为普通央行票据和专项央行票据\nD. 央票以6个月以下为主",
            "answer": "C",
            "explain": "本题考查中央银行票据的特点。\nA选项表述错误，央票市场的参与主体只有央行及经过特许的商业银行和金融机构(并非央票市场的参与主体)"
        },
        {
            "title": "一家制造型企业所发行的固定利率债券被某评级机构提高了评级，该债券的价格也相应有所上升。这一价格的上升最（　　）。",
            "question": "A. 该债券信用风险的降低\nB. 该债券流动性风险的提高\nC. 该债券再投资风险的降低\nD. 该债券提前赎回风险的提高",
            "answer": "A",
            "explain": "本题考查债券的风险。\n债券的信用风险又叫违约风险，是指债券发行人未按照契约的规定支付债券的本金和利息，给债券投资者带来损失的风险。"
        }, {
            "title": "通常情况下，企业现金流量表的基本结构可以分为（　　）。",
            "question": "A. 现金流入、现金流出、净现金流\nB. 收入、费用、净利润\nC. 资产、负债、所有者权益\nD. 经营活动产生的现金流量、投资活动产生的现金流量、筹资活动产生的现金流量",
            "answer": "D",
            "explain": "本题考查现金流量表。\n现金流量表的组成部分包括："
        },
        {
            "title": "在质押式回购期间，若发生质押的债券派息，则对利息的处理方式为（　　）。",
            "question": "A. 双方可以协商确定利息的归属\nB. 归资金融入方所有\nC. 归逆回购方所有\nD. 归资金融出方所有",
            "answer": "B",
            "explain": "本题考查质押式回购的相关规定。\n质押式回购是指交易双方进行的以债券为权利质押的一种短期资金融通业务。质押式回购在回购期间，资金融入方"
        },
        {
            "title": "票面金额为100元的2年期债券，年票息率6%，当期市场价格为95元，则该债券的到期收益率为（　　）。",
            "question": "A. 8.80%\nB. 5.50%\nC. 10.10%\nD. 6.50%",
            "answer": "A",
            "explain": "本题考查到期收益率的计算。\n到期收益率公式为："
        },
        {
            "title": "关于债券型基金与货币市场基金，以下说法中正确的是（　　）。",
            "question": "A. 债券基金的投资组合久期越长，面临的利率风险越小\nB. 根据目前法规，封闭式债券基金的杠杆率上限为200%\nC. 根据目前法规，货币基金平均剩余期限不得超过240天\nD. 根据目前法规，货币基金债券正回购的资金余额不得超过净资产的40%",
            "answer": "B",
            "explain": "本题考查债券基金与货币市场基金的相关规定。"
        },
        {
            "title": "债券承销商将承销的债券向其他结算成员进行承销额度过户的业务叫做（　　）。",
            "question": "A. 分销业务\nB. 质押式回购业务\nC. 债券远期交易\nD. 债券借贷业务",
            "answer": "A",
            "explain": "本题考查分销业务的概念。\nA选项符合题意，分销业务是指承销商在发行期内将承销的债券向其他结算成员(和分销认购人)进行承销额度的过户。"
        },
        {
            "title": "关于预期损失，以下表述正确的是（　　）。",
            "question": "A. 预期损失是一个分位值\nB. 预期损失的估算方法有参数法、历史模拟法和蒙特卡洛模拟法\nC. 预期损失是指在给定时间区间和置信区间内，投资组合损失的期望值\nD. 预期损失，又称在险价值、尾部损失、条件风险价值",
            "answer": "C",
            "explain": "本题考查预期损失。\nA选项表述错误，C选项表述正确，预期损失，是指在给定时间区间和置信区间内，投资组合损失的期望值。"
        }, {
            "title": "已知某私募基金银行存款100万元，股票投资20万元，基金投资40万元，已计提管理费2.3万元，托管费0.8万元，业绩报酬5万元，该基金总负债分别为（　　）。",
            "question": "A. 60万元，8.1万元\nB. 160万元，8.1万元\nC. 60万元，3.1万元\nD. 160万元，3.1万元",
            "answer": "B",
            "explain": "本题考查基金总资产与总负债的计算。\n本题中，该私募基金银行存款100万元，股票投资20万元，基金投资40万元，因此其总资产=100+20+40=160万元。已计提管理费2.3万元，托管费0.8万元，业绩报酬5万元。"
        },
        {
            "title": "关于债券回购风险，以下表述正确的是（　　）。",
            "questions": "I、若交易发起人抵押出债券、借入资金，则该交易称为债券正回购<br>II、正回购方目的在于获得利息收入<br>III、正回购比例低的债券基金杠杆比例低<br>IV、债券回购是一种收益稳定、无信用风险的投资品种",
            "question": "A. I、II、III\nB. II、IV\nC. II、III、IV\nD. I、III",
            "answer": "D",
            "explain": "本题考查债券回购风险。\nI项正确，II项错误，正回购方目的在于获得利息收入。\nIII项正确，IV项错误，债券回购是一种收益稳定、无信用风险的投资品种。"
        },
        {
            "title": "（　　）是测量债券价格相对于利率变动的敏感性指标。",
            "question": "A. 加权平均投资组合收益率\nB. 基点价格值\nC. 价格变动收益率值\nD. 久期",
            "answer": "D",
            "explain": "本题考查久期。\nA选项不符合题意，加权平均投资组合收益率是对投资组合中所有债券的收益率进行加权平均后得到的收益率。\n久期是测量债券价格相对于利率变动的敏感性指标。"
        },
        {
            "title": "某上市公司分配方案为每10股送3股，派2元现金，同时每10股配两股，配股价为5元，该股权登记日收盘价为12元，则该股权登记日收盘价为（　　）。",
            "question": "A. 8.53\nB. 6.8\nC. 9.08\nD. 6.93",
            "answer": "A",
            "explain": "本题考查除权参考价的计算。\n除权（息）参考价=（当前收盘价-现金红利+配股价格×配股比率）×（1+配股比率+送股比率）。"
        },
        {
            "title": "各项技术逐渐成熟，产品市场基金形成并不断扩大属于（　　）。",
            "question": "A. 成熟期\nB. 初创期\nC. 衰退期\nD. 成长期",
            "answer": "D",
            "explain": "本题考查行业生命周期。\n在成长期，各项技术逐渐成熟，产品的市场也基本形成并不断扩大，公司利润开始逐步上升，公司股价逐步上涨。"
        },
        {
            "title": "关于回购协议，以下表述错误的是（　　）。",
            "question": "A. 中国人民银行可将回购协议作为工具进行公开市场操作\nB. 国债回购可以分为质押式国债和买断式国债\nC. 国债回购市场存在场内交易市场和场外交易市场\nD. 正回购存在信用风险，逆回购方不存在信用风险",
            "answer": "D",
            "explain": "本题考查回购协议。\nA选项表述正确，中国人民银行以此为工具进行公开市场操作，方便中央银行投放（收回）基础货币，形成合理的短期利率。\nB、C选项表述正确，按逆回购方是否有权处置回购协议的标的国债划分，国债回购包括质押式国债和买断式国债；国债回购市场存在场内交易市场和场外交易市场。"
        }, {
            "title": "识别和预测行业动态变化的重要且有效途径的方法是（　　）。",
            "question": "A. 景气度调查\nB. “相对强度”理论体系\nC. 行业生命周期\nD. 道氏理论",
            "answer": "A",
            "explain": "本题考查行业景气度。\n如何正确识别各行业指标波动的幅度和频率，识别行业的动态变化，是科学投资决策的一项重要内容。而景气度是识别行业动态变化的重要且有效的途径。"
        },
        {
            "title": "基金业绩评价应考虑的因素包括（　　）。",
            "questions": "I、基金管理规模<br>II、时间区间<br>III、综合考虑风险和收益",
            "question": "A. II、III\nB. I、II\nC. I、II、III\nD. I、III",
            "answer": "C",
            "explain": "本题考查影响基金业绩评价的因素。\nI项符合题意，基金管理规模的大小影响基金管理人的投资行为，进而影响基金业绩，因而基金业绩评价需考虑基金的基金收益率，是基金业绩评价应考虑的因素。"
        },
        {
            "title": "关于编制证券价格指数时所使用的加权平均法，以下表述正确的是（　　）。",
            "question": "A. 为使数据均衡，一般来说，在市场上地位越重要的证券所分配到的权数越小\nB. 可派式加权法是一种特殊的加权方法，样本证券的权重都相等\nC. 目前市场上股票指数大多为上市股数加权\nD. 加权平均法按照样本股票在市场上的不同地位赋予其不同的权重",
            "answer": "D",
            "explain": "本题考查加权平均法。\n加权平均法首先按样本股票在市场上的不同地位赋予其不同的权数，即地位重要的权数大，地位次要的权数小。权数的选择，可以是股票的成交金额，也可以是它的上市股数或市值。目前市场上股票指数大多为市值加权。"
        },
        {
            "title": "某公司发行的累积优先股票面的价值为100元，股息率为10%。如公司今年普通股每股分配股息2元，则该累积优先股每股可分配股息（　　）元。",
            "question": "A. 10\nB. 8\nC. 至少10\nD. 2",
            "answer": "C",
            "explain": "本题考查累积优先股的股息分配。\n累积优先股通常承诺一个固定的股息，任何未支付的股息可以累积起来，在普通股持有人收到股息前，用以后财会年度的盈利一起付清。题中显示普通股股东会分配股息，因此优先股股东会收到今年股息和往年股息（如有），股东今年股息为100x10%=10元，因此优先股息至少为10元。"
        },
        {
            "title": "根据现行估值原则，对于在交易所公开增发但未上市新股，应采用的估值价是（　　）。",
            "question": "A. 成本价\nB. 成本价和交易所上市的同一股票市价孰高价\nC. 交易所上市的同一股票市价\nD. 成本价和交易所上市的同一股票市价孰低价",
            "answer": "C",
            "explain": "本题考查交易所发行未上市品种的估值。\n交易所发行未上市品种的估值方法：\n(1)首次发行未上市的股票和权证，采用估值技术确定公允价值，在估值技术难以可靠计量公允价值的情况下按成本计量；\n(2)送股、转增股、配股和公开增发新股等发行未上市股票，按交易所上市的同一股票的市价估值；(C选项符合题意)"
        },
        {
            "title": "有两条关于期货市场功能的论述：\nI、期货市场最基本的功能就是风险管理，期货市场可以消除大多数金融风险，增强了整个金融系统的稳定性；\nII、期货市场提高了供求信息的利用效率，标准合约又增加了市场流动性，为现货市场提供了参考价格，起到了价格发现的功能。对这两条论述判断正确的是（　　）。",
            "question": "A. I错误，II错误\nB. I错误，II正确\nC. I正确，II正确\nD. I正确，II错误",
            "answer": "B",
            "explain": "本题考查期货市场的基本功能。"
        }, {
            "title": "关于沪港通，以下表述错误的是（　　）。",
            "question": "A. 沪港通分为沪股通和港股通两部分\nB. 沪股通只能买卖规定范围内的上海证券交易所上市的股票\nC. 沪港通的双向交易分别以人民币和港币作为结算单位\nD. 沪港通试点2014年4月10日开始实施",
            "answer": "C",
            "explain": "本题考查沪港通的概念。\n沪港通的双向交易均以人民币作为结算单位，这在一定程度上促进了人民币的交投量与流转量增加，为"
        },
        {
            "title": "关于完全复制、抽样复制、优化复制三种指数复制方法，以下表述正确的是（　　）。",
            "question": "A. 完全复制跟踪误差最大\nB. 抽样复制所使用的样本股票数目最多\nC. 优化复制跟踪误差最大\nD. 优化复制所使用的样本股票数目最多",
            "answer": "C",
            "explain": "本题考查证券价格指数跟踪的方法。\n完全复制、抽样复制、优化复制三种指数复制方法，所使用的样本股票的数量依次递减，但跟踪误差通常依次增加。"
        },
        {
            "title": "关于期货交割，以下表述正确的是（　　）。",
            "question": "A. 期货交易中绝大多数交易者都以实物交割的方式了结交易\nB. 期货交易卖方在交易前需备有足量的实物以备交割\nC. 交割是平仓方式的一种，另一种方式是对冲平仓\nD. 股票指数期货通常采用实物交割",
            "answer": "C",
            "explain": "本题考查期货交割的方式。\nA、D选项表述错误，期货合约一般用现金进行结算，有些金融期货合约的标的资产不方便或不可能进行有形交割，只能以现金结算，如股票指数期货。\nB选项表述错误，期货合约绝大多数通过对冲相抵消，通常用现金结算，极少实物交割。因此若没有提前说明要进行实物交割，卖方一般不用在交易前备足实物。"
        },
        {
            "title": "基金公司中，负责制定投资组合具体方案的部门是（　　）。",
            "question": "A. 研究部\nB. 投资决策委员会\nC. 投资部\nD. 交易部",
            "answer": "C",
            "explain": "本题考查投资部的职能。\nA选项不符合题意，研究部是基金投资运作的基础部门，通过对宏观经济形势、行业状况、上市公司等进行详细分析和研究，提出行业资产配置建议，并非负责制定投资组合具体方案。"
        },
        {
            "title": "关于基金公司投资管理业务，以下表述错误的是（　　）。",
            "question": "A. 基金公司投资管理业务受中国证监会监管\nB. 基金公司的主要利润来源是所管理产品的投资收益\nC. 投资管理部门体现着基金公司的核心竞争力\nD. 投资管理业务是基金管理公司最核心的一项业务",
            "answer": "B",
            "explain": "本题考查基金公司的投资管理业务。\nA选项表述正确，基金公司投资管理业务受中国证监会监管。\nB选项表述错误，基金公司的主要利润来源是与资产规模相匹配的管理费用，而非产品的投资收益。"
        },
        {
            "title": "境内机构投资者开展境外证券投资业务时，应当由具有证券投资基金托管资格的（　　）银行负责资产托管业务，而托管人可以委托符合条件的管人负责境外资产托管业务。",
            "question": "A. 境外;境外\nB. 境内;境外\nC. 境外;境内\nD. 境内;境内",
            "answer": "B",
            "explain": "本题考查合格境内机构投资者。\n境内机构投资者开展境外证券投资业务时，应当由具有证券投资基金托管资格的境内银行负责资产托管业务，而托管人可以委托符合条件的管人负责境外资产托管业务。"
        }, {
            "title": "基金经理在进行战术资产配置时，需要考虑的因素包括（　　）。",
            "questions": "I、市场估值的变化<br>II、政治经济状况<br>III、投资者的风险承受能力<br>IV、市场动态的把握",
            "question": "A. I、II、IV\nB. I、III、IV\nC. III、IV\nD. I、III",
            "answer": "A",
            "explain": "本题考查战术资产配置。\n战略资产配置(SAA)是为了满足投资者风险与收益目标所做的长期资产的配比;是根据投资者的风险承受能力，对资产做出一种尽可能满足投资者需求的规划和安排(Ⅲ项错误)。"
        },
        {
            "title": "货币市场工具在金融市场中发挥着十分重要的功能，下列关于货币市场工具的功能描述错误的是（　　）。",
            "question": "A. 为商业银行管理流动性以及企业融通短期资金提供有效的手段\nB. 因货市市场工具交易而形成的短期利率在整个市场的利率体系中充当基准利率\nC. 是判断市场上银根松紧程度的重要指标\nD. 有效降低金融市场的系统性风险",
            "answer": "D",
            "explain": "本题考查货币市场工具的功能。\n货币市场工具的功能包括：\n(1)为商业银行管理流动性以及企业融通短期资金提供了有效的手段：(A选项描述正确)\n(2)因货币市场工具交易而形成的短期利率在整个市场的利率体系中充当了基准利率，是判断市场上银根松紧程度的重要指标。"
        },
        {
            "title": "关于证券交易所，以下表述错误的是（　　）。",
            "question": "A. 证券交易所本身不能决定证券交易的价格\nB. 我国的证券交易所包括上海证券交易所和深圳证券交易所\nC. 我国证券交易所的设立和解散由国务院决定\nD. 我国的证券交易所都采用公司制",
            "answer": "D",
            "explain": "A选项表述正确，在我国，证券交易所是为证券集中交易提供场所和设施，组织和监督证券交易，实行自律管理的法人，其不能决定证券交易的价格。"
        },
        {
            "title": "关于各类大宗商品投资，以下表述正确的是（　　）。",
            "question": "A. 大豆、稻谷、小麦的期货被称为三大农产品期货\nB. 相比国外商品期货市场，国内商品期货市场，在石油、天然气等领域占据着定价权的制高点\nC. 目前国际上可交易的贵金属类大宗商品主要包括金、银、钨等\nD. 基础原材料类大宗商品是制造业发展的基础，与生产经营活动密切相关",
            "answer": "D",
            "explain": "本题考查大宗商品的类型。\nA选项表述错误，玉米、大豆、小麦的期货被称为三大农产品期货。\nB选项表述错误，相比国内，国际商品期货市场在石油、天然气等领域占据着大宗商品定价权的制高点。\nC选项表述错误，目前国际上可交易的贵金属类大宗商品主要包括黄金、白银、铂金等。"
        },
        {
            "title": "关于不动产投资的含义和特点，以下表述错误的是（　　）。",
            "question": "A. 直接的不动产投资流动性较差，通常表现为若要快速转售，投资者往往要承担较大折价损失\nB. 不动产投资具有异质性，这使得不动产估值具有一定的难度\nC. 直接的不动产投资金额大且难以拆分，这意味着该项投资可能会占据到一个投资组合的很大比例\nD. 不动产投资是指投资者直接出资购买商业房地产，用于出租获取租金收益或等待增值之后出售获取增值收益",
            "answer": "D",
            "explain": "本题考查不动产投资的含义和特点。\n不动产投资的特点：\n(1)异质性：每一项不动产在地理位置、产权类型、用途和使用率等方面而言都是独特的，受法律法规、政策、宏观环境和货币环境等因素影响较多。这给房地产估值带来了困难(B选项表述正确)。"
        },
        {
            "title": "关于大额可转让定期存单，以下表述正确的是（　　）。",
            "question": "A. 大额可转让定期存单在二级市场上可能存在不易及时变现的风险\nB. 大额可转让定期存单的利率不可以是浮动利率\nC. 大额可转让定期存单的利率一般要低于同期定期存款\nD. 大额可转让定期存单的期限较长，一般都在1年以上",
            "answer": "A",
            "explain": "本题考查大额可转让定期存单。"
        }, {
            "title": "某可转换债券面额为100元，市场价格为105元，规定其转换价格为10元，则其转换比例为（　　）。",
            "question": "A. 10.5\nB. 10\nC. 9.5\nD. 20.5",
            "answer": "B",
            "explain": "本题考查可转换债券。\n转换比例=债券面值/转换价格=100/10=10。"
        },
        {
            "title": "三位投资者各有一笔资金，希望购买基金。甲投资者的资金随时需要用来支付不时之需，流动性要求高，不希望损失本金；乙投资者期望获取较高收益，短期内没有资金使用需求；丙投资者的风险承受能力较小，不希望损失本金，短期内没有资金使用需求，但希望有机会分享涨带来的收益。根据以上信息，回答以下三题。\n(1) 乙投资者适合投资的基金类型是（　　）。",
            "question": "A. 避险策略基金\nB. 货币市场基金\nC. 股票基金\nD. 债券基金",
            "answer": "C",
            "explain": "本题考查股票基金。"
        },
        {
            "title": "三位投资者各有一笔资金，希望购买基金。甲投资者的资金随时需要用来支付不时之需，流动性要求高，不希望损失本金；乙投资者期望获取较高收益，短期内没有资金使用需求；丙投资者的风险承受能力较小，不希望损失本金，短期内没有资金使用需求，但希望有机会分享涨带来的收益。根据以上信息，回答以下三题。\n(2) 以下表述错误的是（　　）。",
            "question": "A. 乙投资者可以购买股票型基金或混合型基金\nB. 投资期限的长短影响投资者的风险态度以及对流动性的要求\nC. 甲投资者购买基金需要兼顾流动性和安全性\nD. 投资者购买基金无需考虑其自身的风险承受能力",
            "answer": "D",
            "explain": "本题考查投资者需求。"
        },
        {
            "title": "三位投资者各有一笔资金，希望购买基金。甲投资者的资金随时需要用来支付不时之需，流动性要求高，不希望损失本金；乙投资者期望获取较高收益，短期内没有资金使用需求；丙投资者的风险承受能力较小，不希望损失本金，短期内没有资金使用需求，但希望有机会分享涨带来的收益。根据以上信息，回答以下三题。\n(3) 丙投资者应当选择以下哪个类型的基金（　　）。",
            "question": "A. 避险混合型基金\nB. 货币市场基金\nC. 股票基金\nD. 债券基金",
            "answer": "D",
            "explain": "本题考查债券基金。\n丙投资者的风险承受能力较小，不希望损失本金，短期内没有资金使用需求，但希望有机会分享涨带来的收益，因此适合选择债券基金。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-1.js